import { AsciiText } from '../framework/AsciiText';
export class NovastarVxSeries {
    constructor(socket, log) {
        this.socket = socket;
        this.input = 0;
        this.asyncHandlers = [
            {
                name: 'modelId',
                regExp: /\x55\xaa\x00{2}\xfe\x00{7}\x02\x00{3}\x02\x00[\s\S]{2}/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x00,
                        0x00,
                        0x00,
                        0xfe,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x02,
                        0x00,
                        0x00,
                        0x00,
                        0x02,
                        0x00,
                        0x0c,
                        0x62,
                    ]));
                },
            },
            {
                name: 'brightnessSet',
                regExp: /\x55\xaa\x00\x00\xfe\xff\x01\xff\xff\xff\x01\x00\x01\x00\x00\x02\x01\x00([\s\S])[\s\S]{2}/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x00,
                        0x00,
                        0xff,
                        0xfe,
                        0x01,
                        0xff,
                        0xff,
                        0xff,
                        0x01,
                        0x00,
                        0x01,
                        0x00,
                        0x00,
                        0x02,
                        0x00,
                        0x00,
                    ]));
                },
            },
            {
                name: 'presetSet',
                regExp: /\x55\xaa\x00{2}\xfe\x00{5}\x01\x00{2}\x01\x51\x13\x01\x00([\s\S])[\s\S]{2}/,
                callback: (match) => {
                    this.socket.send(this.makeCommand([
                        0x00,
                        0x00,
                        0x00,
                        0xfe,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x01,
                        0x00,
                        0x00,
                        0x01,
                        0x51,
                        0x13,
                        0x00,
                        0x00,
                    ]));
                },
            },
        ];
        this.sendTerminator = '';
    }
    commandExtractor(buffer) {
        for (let i = 0; i < buffer.length - 2; i++) {
            // commands start with 0xaa 0x55
            if (buffer.charCodeAt(i) === 0x55 &&
                i < buffer.length - 1 &&
                buffer.charCodeAt(i + 1) === 0xaa) {
                let checksum = 0x5555;
                let j = i + 2;
                while (j < buffer.length - 2) {
                    checksum += buffer.charCodeAt(j);
                    const checksumL = checksum & 0x00ff;
                    const checksumH = (checksum & 0xff00) >> 8;
                    if (checksumL === buffer.charCodeAt(j + 1) &&
                        checksumH === buffer.charCodeAt(j + 2)) {
                        const command = buffer.slice(i, j + 3); // include the checksum
                        buffer = buffer.slice(j + 3);
                        return { command, buffer };
                    }
                    j++;
                }
            }
        }
        return undefined;
    }
    makeCommand(data) {
        const checksum = data.reduce((sum, p) => sum + p, 0x5555);
        const bytes = [0xaa, 0x55, ...data, checksum & 0x00ff, (checksum & 0xff00) >> 8];
        return AsciiText.decode(bytes);
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = parseInt(videoInput.code, 10);
            if (this.input === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.input = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0;
    }
}
NovastarVxSeries.emulatorType = 'socketEmulator';
NovastarVxSeries.key = '-NQ6EJ1GRSsvcQVVX3w0';
